/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SocialType {
    FACEBOOK = 'facebook',
    GOOGLE = 'google',
    ZACC = 'zacc',
    APPLE = 'apple',
    GUEST = 'guest',
}
